module.exports = __webpack_public_path__ + "no-logo.svg?f04c9e2c1c8c3e28130d451f23a56111";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no-logo.svg
// module id = 267
// module chunks = 0